import { Roles } from '@/entities/roles'
import { TopupModel, TopupModelMerchant } from '@/entities/topup'
import { TopupStatusIcons, TopupStatusTitles } from '@/entities/topups'
import { formatRequisitToType } from '@/features/requisites'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { DealIcon } from '../icons/DealIcon'
import { ItemBaseBlock } from '../ItemBaseBlock/ItemBaseBlock'

export const DealBlock = ({
  data,
  deviceName,
  userRole,
}: {
  data: TopupModel | TopupModelMerchant
  deviceName?: string
  userRole: Roles | null
}) => {
  const isTrader = userRole === Roles.Trader
  const isMerchant = userRole === Roles.Merchant

  const subtitleClasses = 'text-sm text-text-secondary'
  const columnClasses = 'flex flex-col gap-4 gap-[10px] md:gap-4'

  const iconStatus = TopupStatusIcons[data.status]

  if (isTrader) {
    const traderData = { ...data } as TopupModel

    const requisite = formatRequisitToType(
      traderData.paymentRequisitProfile?.type,
      traderData.paymentRequisitProfile?.value
    )

    return (
      <ItemBaseBlock title="Сделка" id={traderData.id} type="deal">
        <div className="flex md:flex-row flex-col justify-between items-start gap-6 md:gap-2 text-sm">
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Сделка</span>
            <div className="flex items-center gap-3">
              <DealIcon status={iconStatus} />
              <div className="flex flex-col">
                <span className="font-klein font-medium">
                  {TopupStatusTitles[traderData.status]}
                </span>
                <span className="text-text-secondary">{formatDate(traderData.createdAt)}</span>
              </div>
            </div>
          </div>
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Реквизит</span>
            <div className="flex flex-col">
              <span className="font-klein font-medium">{requisite}</span>
              <span className="text-text-secondary">
                {traderData.requisitProfile?.bankToName ?? ''}
              </span>
            </div>
          </div>
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Сумма</span>
            <div className="flex flex-col">
              <span className="font-klein font-medium">
                {formatCurrency(traderData.amountFrom, traderData.currencyFrom)}
              </span>
              <span className="text-text-secondary">
                {formatCurrency(traderData.amountTo, traderData.currencyTo)}
              </span>
            </div>
          </div>
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Устройство</span>
            <div className="flex flex-col">
              <span className="font-klein font-medium">{deviceName}</span>
              <span className="text-text-secondary">{traderData.deviceProfile?.id}</span>
            </div>
          </div>
        </div>
      </ItemBaseBlock>
    )
  }

  if (isMerchant) {
    const merchantData = { ...data } as TopupModelMerchant

    const requisite = formatRequisitToType(
      merchantData.paymentRequisitToType,
      merchantData.paymentRequisitToValue
    )

    return (
      <ItemBaseBlock title="Сделка" id={merchantData.id} type="deal">
        <div className="flex md:flex-row flex-col justify-between md:justify-start items-start gap-6 md:gap-20 text-sm">
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Сделка</span>
            <div className="flex items-center gap-3">
              <DealIcon status={iconStatus} />
              <div className="flex flex-col">
                <span className="font-klein font-medium">
                  {TopupStatusTitles[merchantData.status]}
                </span>
                <span className="text-text-secondary">{formatDate(merchantData.createdAt)}</span>
              </div>
            </div>
          </div>
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Реквизит</span>
            <div className="flex flex-col">
              <span className="font-klein font-medium">{requisite}</span>
            </div>
          </div>
          <div className={`${columnClasses}`}>
            <span className={`${subtitleClasses}`}>Сумма</span>
            <div className="flex flex-col">
              <span className="font-klein font-medium">
                {formatCurrency(merchantData.amountFrom, merchantData.currencyFrom)}
              </span>
              <span className="text-text-secondary">
                {formatCurrency(merchantData.amountTo, merchantData.currencyTo)}
              </span>
            </div>
          </div>
        </div>
      </ItemBaseBlock>
    )
  }
}
